module.exports = __webpack_public_path__ + "static/1-fef460a33b8cc709c1d4ec1cba65e8a2.svg";